import BaseComponent from 'foundation/base-component';
import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import WeglotScript from './weglot-script';

class WeglotComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        ReactDOM.render(
            <Fragment>
                <WeglotScript options={this.options} />
            </Fragment>,
            this.element
        );
    }
}

export default WeglotComponent;
